export default function ChainsIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="3.8" r="1.2" fill="currentColor" />
      <line x1="10" y1="5.4" x2="10" y2="9.6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <line x1="7" y1="6.8" x2="13" y2="6.8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="10" y1="9.6" x2="7.2" y2="15" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <line x1="10" y1="9.6" x2="12.8" y2="15" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <circle cx="7" cy="6.8" r="0.85" fill="currentColor" />
      <circle cx="10" cy="9.6" r="0.9" fill="currentColor" />
      <circle cx="13" cy="6.8" r="0.85" fill="currentColor" />
    </svg>
  );
}
